<template>
  <div class="workorderHistoryCodeInformation table-responsive col-12">
    <li
      style="
        display: block;
        color: #000000;
        font-family: dfyuanstd-w5, dfyuanstd-w3;
        font-size: 1rem;
      "
    >
      工單資訊
    </li>
    <b-table
      :items="workorderHistoryCodeInformationItem"
      :fields="workorderHistoryCodeInformationFields"
      class="text-center workorderHistoryCodeInformation-table-detail"
    >
      <!-- <template #cell(code)="row">
        {{ row.item["code"].code }}
        <br />
        ({{ row.item["code"].org_code }})
      </template> -->
      <template #cell(work_qty)="data">
        {{ data.value.toLocaleString("en-US") }}
      </template>
      <template #cell(standard_total_weight)="data" style="">
        {{ data.value.toLocaleString("en-US") }}
      </template>
    </b-table>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "workorderHistoryCodeInformation",
  data() {
    return {};
  },
  computed: {
    ...mapGetters({
      workorderHistoryCodeInformationFields:
        "workorderHistoryCodeInformation/get_workorderHistoryCodeInformationFields",
      workorderHistoryCodeInformationItem:
        "workorderHistoryCodeInformation/get_workorderHistoryCodeInformationItem",
    }),
  },
};
</script>

<style lang="scss">
.workorderHistoryCodeInformation-table-detail thead th {
  border-top: 1px solid;
}
.workorderHistoryCodeInformation-table-detail th,
.workorderHistoryCodeInformation-table-detail td {
  font-size: 1rem;
  min-width: 65px;
  padding: 0.1rem;
  border-color: #999999 !important;
  border-bottom: 1px solid #999999 !important;
  border-right: 1px solid;
  font-weight: normal;
  background-color: #ffffff;
  vertical-align: middle !important;
}
.workorderHistoryCodeInformation-table-detail th:first-child,
.workorderHistoryCodeInformation-table-detail td:first-child {
  border-left: 1px solid;
}
.workorderHistoryCodeInformation-table-detail {
  margin-bottom: 0px;
}
.workorderHistoryCodeInformation-table-detail thead th {
  color: #000000 !important;
  background-color: #cccccc !important;
}
.workorderHistoryCodeInformation-table-detail
  thead
  tr:last-child
  th:nth-child(1) {
  min-width: 6rem;
}
.workorderHistoryCodeInformation-table-detail
  thead
  tr:last-child
  th:nth-child(2) {
  min-width: 12rem;
}
.workorderHistoryCodeInformation-table-detail
  thead
  tr:last-child
  th:nth-child(3) {
  min-width: 12rem;
}
.workorderHistoryCodeInformation-table-detail
  thead
  tr:last-child
  th:nth-child(4) {
  min-width: 17rem;
}
.workorderHistoryCodeInformation-table-detail
  thead
  tr:last-child
  th:nth-child(5) {
  min-width: 6rem;
}
.workorderHistoryCodeInformation-table-detail
  thead
  tr:last-child
  th:nth-child(6) {
  min-width: 5rem;
}
.workorderHistoryCodeInformation-table-detail
  thead
  tr:last-child
  th:nth-child(7) {
  min-width: 7rem;
}
</style>



// WEBPACK FOOTER //
// src/components/workorderHistoryCodeInformation.vue